import { NotificationIcon as CoreNotificationIcon } from '@zhiyue/core';
import type React from 'react';

type NotificationIconProps = React.ComponentProps<typeof CoreNotificationIcon>;

const NotificationIcon: React.FC<NotificationIconProps> = (props) => (
  <CoreNotificationIcon {...props} />
);

export default NotificationIcon;
